import React from 'react';
import './nlp.css';

const m_main = () => {
    return (
        <div className="m_main__wrap">
            <div className="m_main container">
                <p className="m_main--data">Data Science Global Summit’22</p>
                <h1 className="m_main--title">Natural Language Processing Block</h1>
                <p className="m_main--desc">Learn the latest models, advancements, and trends from the top practitioners and researchers behind NLP</p>
            </div>
        </div>
    );
};

export default m_main;